import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import {
  AgrDaterangePickerModule,
  AgrNotificationEmptyModule,
  AgrPageToolbarModule,
} from '@next/core-lib/components';
import { AgrFormModule } from '@next/core-lib/form';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SharedModule } from '../shared/shared.module';
import { TechnicalResultComponent } from './components/technical-result/technical-result.component';
import { CompanyStructureEffects } from './store/effects/technical-result.effects';
import { companyStructureReducer } from './store/reducers/technical-result.reducers';

@NgModule({
  imports: [
    AgrFormModule,
    AgrPageToolbarModule,
    AgrNotificationEmptyModule,
    AgrDaterangePickerModule,
    CommonModule,
    MatButtonModule,
    MatDatepickerModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSortModule,
    MatSlideToggleModule,
    MatTableModule,
    MatListModule,
    SharedModule,
    TechnicalResultComponent,
  ],
  providers: [
    provideState('technical-result', companyStructureReducer),
    provideEffects([CompanyStructureEffects]),
  ],
})
export class TechnicalResultModule {}
